import * as React from 'react';
import { colors } from '../../../index';

const IconPin = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 14",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.85l-2.74-2.9 2.63.64 4.2-3.87V0L14 4.51l-2-.1-3.57 4.4.42 2.37-2.62-2.69-6.2 5.48z"
  }));
};

export default IconPin;